module.exports = __webpack_public_path__ + "static/media/S3N9.cde28031.svg";